import { AppConfigState } from "./appconfig.state";
const configKey = AppConfigState.configKey;
let appConfig = new AppConfigState();
if (localStorage.getItem(configKey))
    appConfig = AppConfigState.fromJson(localStorage.getItem(configKey) || "");
export const state = appConfig;
const getters = {
    appTitle(state) {
        if (!state)
            return "";
        return state.appTitle;
    },
    appVersion(state) {
        if (!state)
            return "";
        return state.applicationVersion;
    },
    appRecaptchaSiteKey(state) {
        if (!state)
            return "";
        return state.recaptchaSiteKey;
    },
    appTutorialUrl(state) {
        if (!state)
            return "";
        return state.tutorialUrl;
    },
    isThirdPartyAuth(state) {
        if (!state || !state.authenticationMethod)
            return false;
        return state.authenticationMethod.toLowerCase() !== "default";
    },
    appReleaseDesignation(state) {
        if (!state)
            return "";
        return state.applicationReleaseDesignation;
    }
};
export const mutations = {
    setAppConfig(state, appConfig) {
        state.applicationName = appConfig.applicationName;
        state.applicationUrl = appConfig.applicationUrl;
        state.applicationVersion = appConfig.applicationVersion;
        state.hasProductionVersion = appConfig.hasProductionVersion;
        state.companyName = appConfig.companyName;
        state.companyPhone = appConfig.companyPhone;
        state.companyEmail = appConfig.companyEmail;
        state.companyWebsite = appConfig.companyWebsite;
        state.companyAddress1 = appConfig.companyAddress1;
        state.companyAddress2 = appConfig.companyAddress2;
        state.companyAddress3 = appConfig.companyAddress3;
        state.companyAddress4 = appConfig.companyAddress4;
        state.postCode = appConfig.postCode;
        state.recaptchaSiteKey = appConfig.recaptchaSiteKey;
        state.tutorialUrl = appConfig.tutorialUrl;
        state.authenticationMethod = appConfig.authenticationMethod;
        state.applicationReleaseDesignation = appConfig.applicationReleaseDesignation;
        state.ssoEnabled = appConfig.ssoEnabled || false;
        state.environmentName = appConfig.environmentName || "Production";
        localStorage.setItem(configKey, JSON.stringify(state));
    }
};
export const actions = {
    configure({ commit }, appConfig) {
        commit("setAppConfig", appConfig);
    }
};
const namespaced = true;
export const appConfigModule = {
    namespaced,
    state,
    actions,
    mutations,
    getters
};
